import { gql } from '@apollo/client';

export const PATIENT_CONSENT_SUBMIT = gql`
  mutation createPatientConsent(
    $consentId: Int
    $patientConsentId: Int
    $versionUuid: String
    $patientFilledFields: JSON
  ) {
    createPatientConsent(
      consentId: $consentId
      patientConsentId: $patientConsentId
      versionUuid: $versionUuid
      patientFilledFields: $patientFilledFields
    ) {
      patientConsent {
        id
      }
    }
  }
`;
